// httpClient.ts
import { API_ROUTES } from "../constants/apiRoutes";

let isRefreshing = false;
let refreshQueue: (() => void)[] = [];

const rawFetch = async (url: string, options: RequestInit = {}) => {
  const headers = new Headers(options.headers);
  headers.set("Content-Type", "application/json");

  const response = await fetch(url, {
    ...options,
    headers,
    credentials: "include", 
  });

  return response;
};

export const httpClient = async (
  url: string,
  options: RequestInit = {},
  _isRetry = false,
): Promise<any> => {
  const response = await rawFetch(url, options);

  const data = await response
    .json()
    .catch(() => ({}));

  if (response.ok) {
    return data;
  }

  const isAuthEndpoint =
    url === API_ROUTES.LOGIN || url === API_ROUTES.REFRESH;

  if (response.status === 401 && !_isRetry && !isAuthEndpoint) {
    if (!isRefreshing) {
      isRefreshing = true;
      try {
        const refreshRes = await rawFetch(API_ROUTES.REFRESH, {
          method: "POST",
        });

        isRefreshing = false;

        if (!refreshRes.ok) {
          refreshQueue = [];
          window.location.href = "/login";
          throw new Error("نشست شما منقضی شده است");
        }

        refreshQueue.forEach((cb) => cb());
        refreshQueue = [];

        return httpClient(url, options, true);
      } catch (err) {
        isRefreshing = false;
        refreshQueue = [];
        window.location.href = "/login";
        throw err;
      }
    }

    return new Promise((resolve, reject) => {
      refreshQueue.push(() => {
        httpClient(url, options, true).then(resolve).catch(reject);
      });
    });
  }

  const error = new Error(data.message || "خطای سرور") as Error & {
    status?: number;
  };
  error.status = response.status;
  throw error;
};
